export default __webpack_public_path__ + "static/media/fast-icon.022bb80a.svg";